// src/components/DashboardContent.js
import React from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';

const DashboardContent = ({data}) => (
  <Box sx={{ padding: '16px' }}>
    <Typography variant="h4" gutterBottom>
      Dashboard Overview
    </Typography>

    {/* Main dashboard grid */}
    <Grid container spacing={3}>
      {/* Widget 1 */}
      <Grid item xs={12} sm={6} md={4}>
        <Paper sx={{ padding: '16px', textAlign: 'center' }}>
          <Typography variant="h6">Total Users</Typography>
          <Typography variant="h3">{data.totalUsers}</Typography>
        </Paper>
      </Grid>

      {/* Widget 2 */}
      <Grid item xs={12} sm={6} md={4}>
        <Paper sx={{ padding: '16px', textAlign: 'center' }}>
          <Typography variant="h6">Active Users</Typography>
          <Typography variant="h3">{data.totalActiveUsers}</Typography>
        </Paper>
      </Grid>

      {/* Widget 3 */}
      <Grid item xs={12} sm={6} md={4}>
        <Paper sx={{ padding: '16px', textAlign: 'center' }}>
          <Typography variant="h6">Total Orders</Typography>
          <Typography variant="h3">{data.totalOrders}</Typography>
        </Paper>
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <Paper sx={{ padding: '16px', textAlign: 'center' }}>
          <Typography variant="h6">Total Deleted Users</Typography>
          <Typography variant="h3">{data.totalDeletedUsers}</Typography>
        </Paper>
      </Grid>
    </Grid>
  </Box>
);

export default DashboardContent;
